import { getCalibratedNoiseFloorMeanSquare } from '@shared/DSPHandler/services/MicrophoneService';

export const RANGE_MIN_DB = -60;
export const RANGE_MAX_DB = 0;

const MINIMUM_SIGNAL_TO_NOISE_DB = 3;
const MINIMUM_SIGNAL_TO_NOISE_RATIO = 10 ** (MINIMUM_SIGNAL_TO_NOISE_DB / 10);

const calculateMeanSquare = (samples) => {
  if (!samples?.length) return 0;
  let sum = 0;
  for (let index = 0; index < samples.length; index += 1) {
    sum += samples[index] * samples[index];
  }
  return sum / samples.length;
};

const meanSquareToDb = (meanSquare) => (
  meanSquare > 0
    ? Math.max(RANGE_MIN_DB, Math.min(RANGE_MAX_DB, 10 * Math.log10(meanSquare)))
    : RANGE_MIN_DB
);

export const calculateRmsDb = (samples) => meanSquareToDb(calculateMeanSquare(samples));

export const calculateNoiseCompensatedRmsDb = (samples) => {
  const meanSquare = calculateMeanSquare(samples);
  if (!meanSquare) return RANGE_MIN_DB;

  const noiseFloorMeanSquare = getCalibratedNoiseFloorMeanSquare();
  if (!noiseFloorMeanSquare) return meanSquareToDb(meanSquare);

  if (meanSquare / noiseFloorMeanSquare < MINIMUM_SIGNAL_TO_NOISE_RATIO) {
    return RANGE_MIN_DB;
  }

  return meanSquareToDb(meanSquare - noiseFloorMeanSquare);
};